var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 290 290",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.154,128.48c0.11-1.746,0.282-9.765-5.219-15.765c-3.721-4.058-8.987-6.115-15.646-6.115l-16.642-0.022 c-6.894,0-9.791-8.219-13.743-21.755c-0.284-0.974-0.568-1.949-0.857-2.92c-6.552-22.066-17.825-42.377-31.742-57.189 C190.115,8.545,173.074,0,156.021,0H94.195C42.693,0,0.793,41.937,0.793,93.484v103.209c0,51.45,41.9,93.307,93.402,93.307h101.583 c51.229,0,93.14-41.845,93.429-93.311L289.154,128.48z M80.818,73.106h61.331c11.046,0,20,8.954,20,20s-8.954,20-20,20H80.818 c-11.046,0-20-8.954-20-20S69.772,73.106,80.818,73.106z M205.431,214.225H80.818c-11.046,0-20-8.954-20-20s8.954-20,20-20h124.612 c11.046,0,20,8.954,20,20S216.477,214.225,205.431,214.225z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.2b4bb0cc4e377ce04e11c334da1d480e.svg";
export { ForwardRef as ReactComponent };